<template>
  <div>
    <v-card>
      <v-card-text>
        <h1>แก้ไขโครงการ</h1>
        <div class="form-control" :class="{ 'has-error': errors.has('projectname') }">
          <label>ชื่อโครงการ</label>
          <input
            :data-vv-as="$t('ชื่อโครงการ')"
            v-validate="'required'"
            name="projectname"
            v-model="input.name"
            type="text"
          />
          <span class="text-error" v-if="errors.has('projectname')">{{
            errors.first('projectname')
          }}</span>
        </div>
        <div class="form-control" :class="{ 'has-error': errors.has('description') }">
          <label>รายละเอียดโครงการ</label>
          <input
            :data-vv-as="$t('รายละเอียดโครงการ')"
            v-validate="'required'"
            name="description"
            v-model="input.description"
            type="text"
          />
          <span class="text-error" v-if="errors.has('description')">{{
            errors.first('description')
          }}</span>
        </div>
        <div class="form-control" :class="{ 'has-error': errors.has('phoneno') }">
          <label>เบอร์โทรศัพท์</label>
          <input
            :data-vv-as="$t('phone')"
            v-validate="'required'"
            name="phoneno"
            v-model="input.phoneno"
            type="number"
          />
          <span class="text-error" v-if="errors.has('description')">{{
            errors.first('description')
          }}</span>
        </div>
        <div class="form-control" :class="{ 'has-error': errors.has('goal') }">
          <label>ระยะทางที่ตั้งเป้าไว้</label>
          <input
            :data-vv-as="$t('goal')"
            v-validate="'required'"
            name="goal"
            v-model="input.goal"
            type="number"
          />
          <span class="text-error" v-if="errors.has('goal')">{{ errors.first('goal') }}</span>
        </div>
        <div class="form-control" :class="{ 'has-error': errors.has('endproject') }">
          <label>วันสิ้นสุดโครงการ</label>
          <v-menu
            ref="appointmentStart"
            v-model="showEndproject"
            :close-on-content-click="false"
            full-width
            max-width="290px"
            color="primary"
          >
            <template v-slot:activator="{ on }">
              <div>
                <input
                  type="text"
                  name="endproject"
                  v-validate="'required'"
                  :data-vv-as="$t('endproject')"
                  class="form-control browser-default"
                  :placeholder="$t('วันที่สิ้นสุดโครงการ')"
                  readonly
                  :value="formattedEndprojectDate"
                  v-on="on"
                  clearable
                />
              </div>
            </template>
            <v-date-picker
              v-model="input.endproject"
              no-title
              @input="showEndproject = false"
            ></v-date-picker>
          </v-menu>
          <span class="text-error" v-if="errors.has('endproject')">{{
            errors.first('endproject')
          }}</span>
        </div>
        <div class="form-control" :class="{ 'has-error': errors.has('address') }">
          <label>ที่อยู่</label>

          <autoresize-textarea
            :data-vv-as="$t('address')"
            name="address"
            v-validate="'required'"
            v-model="input.address"
          />
          <span class="text-error" v-if="errors.has('address')">{{ errors.first('address') }}</span>
        </div>

        <v-layout row>
          <v-flex pa-1 xs6>
            <div class="form-control" :class="{ 'has-error': errors.has('latitude') }">
              <label>latitude</label>
              <input
                :data-vv-as="$t('latitude')"
                v-validate="'required'"
                name="latitude"
                v-model="input.latitude"
                type="number"
              />
              <span class="text-error" v-if="errors.has('latitude')">{{
                errors.first('latitude')
              }}</span>
            </div>
          </v-flex>
          <v-flex pa-1 xs6>
            <div class="form-control" :class="{ 'has-error': errors.has('longtitude') }">
              <label>longtitude</label>
              <input
                :data-vv-as="$t('longtitude')"
                v-validate="'required'"
                name="longtitude"
                v-model="input.longitude"
                type="number"
              />
              <span class="text-error" v-if="errors.has('longtitude')">{{
                errors.first('longtitude')
              }}</span>
            </div>
          </v-flex>
        </v-layout>
        <div class="form-control has-error">
          <label>รูปโครงการ</label>
          <uploadfile
            name="picture"
            v-model="input.project_pic"
            @onUploaded="onUploaded"
          ></uploadfile>
        </div>
        <div style="text-align: center; margin-top: 5px">
          <v-btn @click="cancel" outline color="grey">ยกเลิก</v-btn>
          <v-btn
            @click="updateProject"
            :loading="updateloading"
            :disabled="updateloading"
            depressed
            color="primary"
            >บันทึก</v-btn
          >
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import api from '@/api'
import uploadfile from '@/components/elements/uploadfile'
import AutoresizeTextarea from '@/components/elements/AutoresizeTextarea.vue'
import moment from 'moment'

export default {
  props: ['data'],
  data() {
    return {
      input: {},
      updateloading: false,
      cache: '',
      showEndproject: false
    }
  },
  components: {
    uploadfile,
    AutoresizeTextarea
  },
  computed: {
    formattedEndprojectDate() {
      if (this.input.endproject) {
        return moment(this.input.endproject).format('DD-MM-YYYY')
      }
    }
  },
  mounted() {
    this.input = this.data
    this.cache = JSON.stringify(this.input)
  },
  methods: {
    onUploaded() {},
    updateProject() {
      var vm = this
      vm.$validator.validateAll().then((result) => {
        if (!result) {
          // do stuff if not valid.
          vm.goToErrorInput()
          return false
        }

        this.updateloading = true
        var data = {
          id: this.input.id, // id โครงการ
          projectname: this.input.name, // ชื่อโครงการ
          description: this.input.description, // รายละเอียดโครงการ
          project_pic: this.input.project_pic, // URL รูปภาพ
          address: this.input.address,
          phoneno: this.input.phoneno,
          latitude: this.input.latitude,
          longitude: this.input.longitude,
          goal: this.input.goal,
          endproject: this.input.endproject
        }
        api.putrunbetterdonationproject(data, function (error, response) {
          if (error) return console.error(error)
          vm.updateloading = false
          vm.close()
        })
      })
    },
    cancel() {
      this.$emit('cancel')
      this.close()
    },
    close() {
      this.$emit('closedialog', 'edit')
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/runbetter/formEdit.vue